export default __webpack_public_path__ + "static/media/security-icon.cd49ed73.svg";